<template>
  <v-dialog
    v-if="dialog"
    v-model="editDialog"
    v-bind="$attrs"
    :scrollable="isScrollable"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="cancelAction"
  >
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto d-none d-md-block"
        type="article, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        class="mx-auto d-md-none"
        type="list-item-avatar, list-item-three-line, table-tfoot, list-item-two-line, article, table-heading, list-item-three-line, actions"
      ></v-skeleton-loader>
    </div>
    <v-card v-else>
      <v-card-title class="px-3 py-0 px-md-5 py-md-1">
        <span class="text-subtitle-2 text-sm-subtitle-1 text-md-h6 text-lg-h5 font-weight-bold">{{readOnly ? readTitle : editTitle}}</span>
        <v-spacer></v-spacer>
        <v-btn
          text
          icon
          title="Cancelar"
          class="my-2"
          @click="cancelAction"
        >
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text id="dialogBody" class="mt-5 px-3 px-sm-4 px-md-6">
        <v-alert
          type="error"
          elevation="2"
          v-if="formErrors.length > 0"
          dismissible
          class="mt-2 error-alert-message"
          @input="errorsAlertClose"
        >
          <p v-for="error in formErrors" class="mb-0">
            {{error}}
          </p>
        </v-alert>

        
        <slot name="editForm"></slot>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
        <v-btn class="my-2" @click="cancelAction">
          {{editCancelButtonLabel}}
        </v-btn>

        <v-spacer></v-spacer>
        
        <slot name="action1"></slot>
        <slot name="action2"></slot>
        <slot name="action3"></slot>

        <v-btn color="success" class="my-2" @click="confirmAction" v-if="!readOnly">
          {{editSaveButtonLabel}}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on: dialog }" >
      <v-tooltip :top="editButtonTooltipTop" :bottom="!editButtonTooltipTop" :color="buttonColor">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn 
            text 
            v-if="isTextButton"
            v-on="{ ...tooltip, ...dialog }"
            class=""
            :color="buttonColor"
            @click="openAction">
            {{textButton}}
          </v-btn>
          <v-icon
            v-else
            v-on="{ ...tooltip, ...dialog }"
            class="mx-1"
            :color="buttonColor"
            @click="openAction"
          >
          <!-- :title="editButtonLabel" -->
            {{readOnly ? readIcon : editIcon}}
          </v-icon>
        </template>
        <span>{{readOnly ? readTitle : editTitle}}</span>
      </v-tooltip>
    </template>
  </v-dialog>
  <div v-else class="col">
    Em desenvolvimento!
  </div>
</template>

<script>

export default {
  data() {
    return {
      editDialog: null
    };
  },
  props: {
    nestedDialog: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      default: "rgba(0,0,0,.54)"
    },
    dialog: {
      type: Boolean,
      default: true
    },
    formErrors: {
      type: Array,
      default: () => []
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    modelNameSingular: {
      type: String,
      default: "Registro"
    },
    modelNamePlural: {
      type: String,
      default: "Registros"
    },
    editTitle: {
      type: String,
      default: function() {
        return "Edição de " + this.modelNameSingular
      }
    },
    readTitle: {
      type: String,
      default: function() {
        return "Visualização de " + this.modelNameSingular
      }
    },
    editButtonLabel: {
      type: String,
      default: "Editar"
    },
    editCancelButtonLabel: {
      type: String,
      default: "Cancelar"
    },
    editSaveButtonLabel: {
      type: String,
      default: function() {
        return "Salvar" + (this.$vuetify.breakpoint.smAndDown ? "" : " Alterações")
      }
    },
    loading: {
      type: Boolean,
      default: true
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readIcon: {
      type: String,
      default: "mdi-eye"
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    editButtonTooltipTop: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    formErrors: function(val) {
      if (val && val.length > 0) {
        // console.log("scroll")
        // document.getElementById('dialogBody').scrollTop = 0;
        let options = {
          container: '#dialogBody',
          duration: 300,
          offset: 0,
        }
        this.$vuetify.goTo(0, options);
      }
    }
  },
  mounted() {
    // Close modal with 'esc' key
    // document.addEventListener("keydown", (e) => {
    //     if (e.keyCode == 27) {
    //         this.cancelAction();
    //     }
    // });
  },
  methods: {
    cancelAction: function(){
      this.editDialog = false
      this.$emit("edit-cancel-action")
    },
    confirmAction: function(){
      this.$emit("edit-confirm-action")
    },
    openAction: function() {
      this.$emit("edit-open-action")
    },
    closeDialog: function() {
      this.editDialog = false;
    },
    errorsAlertClose: function(val) {
      if (!val) {
        this.$emit("clear-form-errors");
      }
    }
  },
};
</script>

<style scoped>
  ::v-deep .v-slide-group__prev, .v-slide-group__prev--disabled {
    display: none !important;
  }
</style>
